import { useMutation } from '@apollo/react-hooks';
import { notifyFailed, notifySuccess } from 'helpers/notify';
import { Button } from 'modules';
import { SendReportFilesToEmail } from 'queries/ContractOnlineForms/ContractOnlineFormData';
import React, { useEffect, useState } from 'react';

interface SendReportToEmailProps {
  form: GQL.IContractOnlineForm;
}

let timer: any;

const SendReportToEmail = ({ form }: SendReportToEmailProps) => {
  const [sendDisabled, setSendDisabled] = useState<boolean>(false);
  const [sendReportFilesToEmail] = useMutation(SendReportFilesToEmail);

  const onSendDocuments = (): void => {
    sendReportFilesToEmail({
      variables: {
        formId: form.form_id,
      },
    })
      .then((result) => result.data.sendReportFilesToEmail.success)
      .then(() => {
        setSendDisabled(true);
        notifySuccess('Dokumenty boli pridané do fronty na odoslanie !');
      })
      .catch(() => {
        notifyFailed('Dokumenty nebolo možné odoslať !');
      });
  };

  useEffect(() => {
    if (sendDisabled) {
      timer = setTimeout(() => {
        setSendDisabled(false);
      }, 5000);
    }
    return () => {
      clearTimeout(timer);
    };
  }, [sendDisabled]);

  return (
    <Button type="submit" variant="danger" size="sm" className="mt-3" onClick={onSendDocuments} disabled={sendDisabled}>
      Odoslať dokumenty na email
    </Button>
  );
};

export default SendReportToEmail;
